import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ToasterService } from '../../../core/services/toaster-service';

@Component({
  selector: 'app-toaster',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toaster.component.html',
  styleUrl: './toaster.component.scss'
})

export class ToasterComponent {
  isActive = false;
  data: any = {};

  constructor(private readonly toaster: ToasterService) {
    this.toaster.onPop().subscribe((data: any) => {
      this.isActive = true;
      this.data = data;
      setTimeout(() => {
        this.isActive = false;
      }, data?.options?.timeout || 3500);
    });
  }

  getColor() {
    if(this.data.message?.type === 'success') {
      return '#27cf27';
    } else if(this.data.message?.type === 'warning') {
      return 'orange';
    } else {
      return 'red';
    }
  }

}
